import type { AppRouteRecordRaw } from '@/types/router';
import { LAYOUT } from '@/router/constants';

const dataReport: AppRouteRecordRaw = {
  path: '/data-report',
  name: 'DataReport',
  redirect: '/data-report/purchase-hot',
  component: LAYOUT,
  meta: {
    title: '数据报表',
  },
  children: [
    {
      path: 'purchase-hot',
      name: 'PurchaseHot',
      component: () => import('@/views/alliance/purchase-hot/index.vue'),
      meta: {
        title: '采购热点',
      },
    },
    {
      path: 'price-movement',
      name: 'PriceMovement',
      component: () => import('@/views/alliance/price-movement/index.vue'),
      meta: {
        title: '价格异动',
      },
    },
    {
      path: 'market-trend',
      name: 'MarketTrend',
      component: () => import('@/views/alliance/market-trend/index.vue'),
      meta: {
        title: '行情趋势',
      },
    },
    {
      path: 'market-trend-detail/:categoryCode',
      name: 'MarketTrendDetail',
      component: () =>
        import('@/views/alliance/market-trend-detail/index.vue'),
      meta: {
        title: '行情趋势明细',
        hideInMenu: true,
        // 让面包屑正确高亮"行情趋势"父级，构建 "数据报表 > 行情趋势 > 行情趋势明细"
        activeMenu: '/data-report/market-trend',
      },
    },
  ],
};

export default dataReport;
